import { ComboboxOption } from '@reach/combobox';
import 'react';
import warning from 'tiny-warning';
import { createComponent } from '../../../react/components/core/create-component.js';

function _object_without_properties(source, excluded) {
  if (source == null) return {};

  var target = _object_without_properties_loose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * @deprecated Use new Combobox and its sub-components instead
 */


var LegacyComboboxOption = createComponent({
  displayName: 'LegacyComboboxOption',
  root: ComboboxOption,
  propConfig: {
    classNames: ['swan-legacy-combobox-option'],
    processProps: function processProps(_param) {
      var as = _param.as,
          component = _param.component,
          props = _object_without_properties(_param, ["as", "component"]);

      warning(as === undefined && component === undefined, 'props `as` and `component` not supported as ComboboxOption uses 3rd party lib');
      return props;
    }
  }
});
export { LegacyComboboxOption };